import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../ui/card';
import { profileLink } from '../../utils/profile';

export function SellerInfoCard({ seller }) {
  if (!seller) return null;
  return (
    <Card className="mt-6 bg-[#1A1A1A] border border-[#333333] rounded-sm shadow-none">
      <CardContent className="p-4">
        <p className="text-xs tracking-[0.1em] uppercase font-semibold text-[#999999] mb-3">
          Sold By
        </p>
        <Link to={profileLink(seller)} className="flex items-center gap-3 hover:bg-[#333333] p-2 -mx-2 rounded-sm transition-colors" data-testid="seller-info-link">
          {seller.avatar_url ? (
            <img src={seller.avatar_url} alt={seller.name} className="w-12 h-12 rounded-full object-cover" />
          ) : (
            <div className="w-12 h-12 bg-[#22C55E]/10 rounded-full flex items-center justify-center text-[#22C55E] font-bold text-lg">
              {seller.name?.[0]?.toUpperCase() || 'U'}
            </div>
          )}
          <div>
            <p className="font-semibold text-white">{seller.name}</p>
            <p className="text-sm text-[#999999]">{seller.email}</p>
          </div>
        </Link>
      </CardContent>
    </Card>
  );
}
